/*
  PSS: same-day despatch countdown in the announcement bar.
  "Order within 2h 14m to get it as soon as Tuesday 13 October*"

  Rules (all in UK time, Europe/London):
  - Working days are Monday to Friday, excluding the bank holidays listed in the theme editor.
  - Orders before the cut-off on a working day are despatched that day; otherwise on the next working day.
  - Earliest delivery is the next delivery day after despatch. Deliveries run Monday to Saturday
    (never Sunday, never on the listed dates), so Friday despatch arrives Saturday.
  - The timer counts down to the next cut-off. It is shown only when that is under 24 hours away;
    otherwise (Friday afternoon, weekends) the message reads "Order now to get it as soon as …".
  - Hours and minutes only, refreshed every 20 seconds.
  The server-rendered fallback text stays if this script cannot run.
*/
(function () {
  var DAY = 86400000;

  function ukNow() {
    // Current UK wall-clock time, expressed as a UTC timestamp so date maths ignores the visitor's time zone.
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  }

  function key(t) { return new Date(t).toISOString().slice(0, 10); }
  function startOfDay(t) { return t - (t % DAY); }

  function isWorkingDay(t, holidays) {
    var wd = new Date(t).getUTCDay();
    return wd !== 0 && wd !== 6 && holidays.indexOf(key(t)) === -1;
  }

  function nextWorkingDay(dayStart, holidays) {
    var d = dayStart + DAY;
    for (var i = 0; i < 30 && !isWorkingDay(d, holidays); i++) d += DAY;
    return d;
  }

  function isDeliveryDay(t, holidays) {
    var wd = new Date(t).getUTCDay();
    return wd !== 0 && holidays.indexOf(key(t)) === -1;
  }

  function nextDeliveryDay(dayStart, holidays) {
    var d = dayStart + DAY;
    for (var i = 0; i < 30 && !isDeliveryDay(d, holidays); i++) d += DAY;
    return d;
  }

  function plan(now, cutoffMinutes, holidays) {
    var today = startOfDay(now);
    var despatch = today;
    if (!isWorkingDay(today, holidays) || now >= today + cutoffMinutes * 60000) {
      despatch = nextWorkingDay(today, holidays);
    }
    return {
      delivery: nextDeliveryDay(despatch, holidays),
      remaining: despatch + cutoffMinutes * 60000 - now
    };
  }

  function formatRemaining(ms) {
    var mins = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h === 0) return m + 'm';
    return m === 0 ? h + 'h' : h + 'h ' + m + 'm';
  }

  var LONG = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
  var SHORT = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });

  function setText(root, sel, text) {
    var el = root.querySelector(sel);
    if (el && el.textContent !== text) el.textContent = text;
  }

  function update(root) {
    var cut = (root.getAttribute('data-cutoff') || '13:00').split(':');
    var cutoffMinutes = (+cut[0] || 13) * 60 + (+cut[1] || 0);
    var holidays = (root.getAttribute('data-holidays') || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
    var p = plan(ukNow(), cutoffMinutes, holidays);
    var timed = p.remaining < DAY;

    root.classList.toggle('pss-despatch--timed', timed);
    setText(root, '[data-pss-timer]', timed ? formatRemaining(p.remaining) : '');
    setText(root, '[data-pss-date-long]', LONG.format(new Date(p.delivery)).replace(',', ''));
    setText(root, '[data-pss-date-short]', SHORT.format(new Date(p.delivery)).replace(',', ''));
    root.classList.add('pss-despatch--live');
  }

  function init() {
    var roots = document.querySelectorAll('[data-pss-despatch]');
    if (!roots.length) return;
    try {
      roots.forEach(update);
    } catch (e) {
      return; // keep the plain fallback message
    }
    setInterval(function () { roots.forEach(update); }, 20000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) roots.forEach(update);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();